import React, { useState } from "react";
import { toast } from "react-hot-toast";

import bhavishya from "../../assets/Bhavishya.png";
import uploadslip from "../../assets/uploadslip.png";
import qrCode from "../../assets/QR.png"; // <-- apna QR image rename karke yahan rakh do
import CustomDatePicker from "./CustomDatePicker";

const DonateSection = () => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [donationDate, setDonationDate] = useState("");
  const [panNumber, setPanNumber] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [amount, setAmount] = useState("");
  const [status, setStatus] = useState("Individual");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const GOOGLE_FORM_URL =
    "https://docs.google.com/forms/d/e/1FAIpQLSdjocsF4LIBVyMWVT9rrvxvo4wev7LgFgSa_1c21L451M-fkA/formResponse";

  const ENTRY_NAME = "entry.181119600";
  const ENTRY_PHONE = "entry.1714803612";
  const ENTRY_DATE = "entry.1643317050";
  const ENTRY_PAN = "entry.1457843927";
  const ENTRY_EMAIL = "entry.563605255";
  const ENTRY_ADDRESS = "entry.1381663727";
  const ENTRY_STATUS = "entry.548858601";
  const ENTRY_AMOUNT = "entry.1690914067";

  const downloadReceiptPdf = (base64, fileName) => {
    const byteChars = atob(base64);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) byteNumbers[i] = byteChars.charCodeAt(i);
    const blob = new Blob([new Uint8Array(byteNumbers)], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const validateForm = () => {
    if (!name.trim()) return "Name is required";
    if (!phone.trim() || phone.length < 10) return "Enter a valid 10-digit phone number";
    if (!donationDate) return "Donation date is required";
    if (panNumber.trim() && panNumber.trim().length !== 10) return "Enter a valid 10-character PAN";
    if (!email.trim() || !email.includes("@")) return "Enter a valid email address";
    if (!address.trim()) return "Address is required";
    if (!amount.trim() || isNaN(amount) || Number(amount) <= 0) return "Enter a valid donation amount";
    return null;
  };

  const handleOnSubmit = async (e) => {
    e.preventDefault();
    const error = validateForm();
    if (error) { toast.error(error); return; }
    setIsSubmitting(true);
    const formData = new FormData();
    formData.append(ENTRY_NAME, name);
    formData.append(ENTRY_PHONE, phone);
    formData.append(ENTRY_DATE, donationDate);
    formData.append(ENTRY_PAN, panNumber);
    formData.append(ENTRY_EMAIL, email);
    formData.append(ENTRY_ADDRESS, address);
    formData.append(ENTRY_STATUS, status);
    formData.append(ENTRY_AMOUNT, amount);
    try {
      await fetch(GOOGLE_FORM_URL, { method: "POST", mode: "no-cors", body: formData });

      // Send 80G receipt email
      const receiptRes = await fetch("/api/send-receipt", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, phone, donationDate, panNumber, email, address, amount, status }),
      });

      if (!receiptRes.ok) {
        console.error("Receipt email failed:", await receiptRes.text());
        toast.success("Donation submitted! Receipt email could not be sent — our team will send it manually.");
      } else {
        const receiptData = await receiptRes.json();
        if (receiptData.pdfBase64) {
          downloadReceiptPdf(receiptData.pdfBase64, receiptData.fileName || "80G-Receipt.pdf");
        }
        toast.success("Donation submitted! Your 80G receipt has been emailed and downloaded.");
      }

      setName(""); setPhone(""); setDonationDate(""); setPanNumber(""); setEmail("");
      setAddress(""); setAmount(""); setStatus("Individual");
    } catch (err) {
      toast.error("Something went wrong, please try again.");
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="bg-primaryBg min-h-screen py-6 px-4 sm:px-4">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16">

        {/* ───── Left Section ───── */}
        <div className="bg-primaryBg relative lg:sticky lg:top-0 w-full h-auto p-4 sm:p-6">

          {/* Logo */}
          <div className="flex items-center gap-3 mb-6">
            <img src={bhavishya} alt="Bhavishya Trust Logo" className="w-16 sm:w-20 h-16 sm:h-20 object-cover" />
          </div>

          {/* Razorpay */}
          <div className="text-center flex flex-col items-center w-full py-6 bg-[#ECFDF5] rounded-lg p-4 mb-6">
            {/* <h3 className="font-semibold mb-3 text-base sm:text-lg text-[#000000]">
             
            </h3> */}
            <p className="text-xs sm:text-sm font-normal text-[#00000080] mb-4">
              To Donote click the button below
            </p>
            <a
              href="https://rzp.io/rzp/vMLYpKs"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-[#ef5b5b] text-white px-6 py-3 rounded-lg font-semibold mb-3 hover:bg-[#d84a4a] transition text-sm sm:text-base"
            >
              Donate Now with Razorpay
            </a>
            <p className="text-xs text-[#00000080]">You will be redirected to secure payment gateway</p>
          </div>

          {/* OR divider */}
          <div className="flex items-center my-6">
            <div className="flex-grow border-t border-[#71768040]"></div>
            <span className="mx-4 font-normal text-sm sm:text-base text-[#666666]">OR</span>
            <div className="flex-grow border-t border-[#71768040]"></div>
          </div>

          {/* QR Code Section */}
          <div className="w-full mb-6">
            <h3 className="mb-4 text-base sm:text-lg text-center text-[#000000]">
              To Donate Scan the QR Code
            </h3>
            <div className="flex flex-col items-center justify-center bg-[#ECFDF5] rounded-lg p-4 sm:p-6">
              <img
                src={qrCode}
                alt="UPI QR Code"
                className="w-44 sm:w-52 h-44 sm:h-52 object-contain rounded-lg border border-gray-200 shadow-sm"
              />
              <p className="mt-3 text-xs sm:text-sm text-center text-[#00000080]">
                Open any UPI app · Scan the QR · Enter amount · Pay
              </p>
            </div>
          </div>

          {/* OR divider */}
          <div className="flex items-center my-6">
            <div className="flex-grow border-t border-[#71768040]"></div>
            <span className="mx-4 font-normal text-sm sm:text-base text-[#666666]">OR</span>
            <div className="flex-grow border-t border-[#71768040]"></div>
          </div>

          {/* Bank Transfer */}
          <div className="w-full">
            <h3 className="mb-4 text-base sm:text-lg text-center text-[#000000]">For Bank Transfer</h3>
            <div className="w-full p-4 sm:p-6 rounded-lg bg-[#ECFDF5]">
              <div className="space-y-3 sm:space-y-4">
                {[
                  ["Name", "Bhavishya Trust"],
                  ["Bank Name", "ICICI Bank"],
                  ["Account Number", "113905000444"],
                  ["IFSC Code", "ICIC0001139"],
                ].map(([label, value]) => (
                  <div key={label} className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-4">
                    <p className="font-normal text-sm sm:text-base text-[#00000080]">{label}:</p>
                    <p className="text-start sm:text-end font-normal text-sm sm:text-base text-[#000000] break-all">{value}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* ───── Right Section - Form ───── */}
        <div className="bg-[#ef5b5b] w-full h-auto rounded-lg p-5 sm:p-6 text-white">
          <h2 className="w-full text-xl sm:text-2xl text-center font-semibold mb-4">Donate</h2>
          <p className="mb-6 w-full text-sm sm:text-base text-center font-normal leading-relaxed">
            Thanks for donating!
            For 80G Receipt, Please fill out the form below & submit
          </p>

          <form onSubmit={handleOnSubmit} className="w-full space-y-4">
            <div className="mb-4">
              <h3 className="font-semibold text-sm sm:text-base mb-3">DONOR DETAILS</h3>
              <hr className="border-[rgba(255,255,255,0.3)]" />
            </div>

            {/* Name + Phone */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
              <div>
                <label htmlFor="name" className="font-light text-xs sm:text-sm text-white block mb-2">Your Name *</label>
                <input id="name" type="text" value={name} onChange={(e) => setName(e.target.value)} required placeholder="Enter your full name"
                  className="w-full h-10 sm:h-11 text-xs sm:text-sm px-3 py-2 border border-[#FFFFFF80] bg-white rounded-lg text-black placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-30" />
              </div>
              <div>
                <label htmlFor="phone" className="font-light text-xs sm:text-sm text-white block mb-2">Phone Number *</label>
                <input id="phone" type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} required placeholder="Enter 10-digit number"
                  className="w-full h-10 sm:h-11 text-xs sm:text-sm px-3 py-2 border border-[#FFFFFF80] bg-white rounded-lg text-black placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-30" />
              </div>
            </div>

            {/* Donation Date + PAN */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
              <div>
                <label htmlFor="donationDate" className="font-light text-xs sm:text-sm text-white block mb-2">Donation Date *</label>
                <CustomDatePicker
                  id="donationDate"
                  value={donationDate}
                  onChange={setDonationDate}
                  required
                  max={new Date().toISOString().split("T")[0]}
                />
              </div>
              <div>
                <label htmlFor="pan" className="font-light text-xs sm:text-sm text-white block mb-2">PAN Number</label>
                <input id="pan" type="text" value={panNumber} onChange={(e) => setPanNumber(e.target.value.toUpperCase())} placeholder="10-character PAN" maxLength="10"
                  className="w-full h-10 sm:h-11 text-xs sm:text-sm px-3 py-2 border border-[#FFFFFF80] bg-white rounded-lg text-black placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-30" />
              </div>
            </div>

            {/* Email */}
            <div>
              <label htmlFor="email" className="font-light text-xs sm:text-sm text-white block mb-2">Email *</label>
              <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="your.email@gmail.com"
                className="w-full h-10 sm:h-11 text-xs sm:text-sm px-3 py-2 border border-[#FFFFFF80] bg-white rounded-lg text-black placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-30" />
            </div>

            {/* Address */}
            <div>
              <label htmlFor="address" className="font-light text-xs sm:text-sm text-white block mb-2">Address *</label>
              <input id="address" type="text" value={address} onChange={(e) => setAddress(e.target.value)} required placeholder="Enter your complete address"
                className="w-full h-10 sm:h-11 text-xs sm:text-sm px-3 py-2 border border-[#FFFFFF80] bg-white rounded-lg text-black placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-30" />
            </div>

            {/* Status + Amount */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
              <div>
                <label htmlFor="status" className="font-light text-xs sm:text-sm text-white block mb-2">Donated by *</label>
                <select id="status" value={status} onChange={(e) => setStatus(e.target.value)}
                  className="w-full h-10 sm:h-11 text-xs sm:text-sm px-3 py-2 border border-[#FFFFFF80] bg-white rounded-lg text-black focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-30">
                  <option value="Individual">Individual</option>
                  <option value="Organization">Organization</option>
                </select>
              </div>
              <div>
                <label htmlFor="amount" className="font-light text-xs sm:text-sm text-white block mb-2">Donation Amount (₹) *</label>
                <input id="amount" type="number" value={amount} onChange={(e) => setAmount(e.target.value)} required placeholder="Enter amount in rupees" min="1"
                  className="w-full h-10 sm:h-11 text-xs sm:text-sm px-3 py-2 border border-[#FFFFFF80] bg-white rounded-lg text-black placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-30" />
              </div>
            </div>

            {/* Payment Confirmation */}
            <div className="py-4 border-t border-[rgba(255,255,255,0.3)] mt-6">
              <h3 className="uppercase text-xs sm:text-sm font-semibold text-white mb-3">Payment Confirmation</h3>
              <label htmlFor="photoupload" className="font-light text-xs sm:text-sm text-white block mb-3">Upload Payment *</label>
              <div className="flex flex-col items-center justify-center bg-white h-auto border border-[#99A1AF] rounded-lg p-4 sm:p-6 text-center">
                <img src={uploadslip} alt="upload slip" className="w-12 h-12 sm:w-16 sm:h-16 mx-auto mb-3" />
                <input id="photoupload" type="file" accept=".png,.jpg,.jpeg,.pdf"
                  className="text-xs sm:text-sm font-normal text-black outline-none mx-auto file:mr-4 file:py-1 file:px-3 file:rounded file:border-0 file:bg-[#ef5b5b] file:text-white file:cursor-pointer hover:file:bg-[#d84a4a]" />
                <p className="mt-2 text-center text-black text-xs">PNG, JPG or PDF (max 5MB)</p>
              </div>
              <p className="text-xs sm:text-sm font-light mt-3 text-[rgba(255,255,255,0.8)]">
                Upload payment screenshot after completing payment via Razorpay / Bank Transfer / QR
              </p>
            </div>

            {/* Submit */}
            <button type="submit" disabled={isSubmitting}
              className="w-full bg-black text-white py-3 mt-6 rounded-lg font-semibold transition hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed text-sm sm:text-base">
              {isSubmitting ? "Submitting..." : "Send Donation Details"}
            </button>

            <p className="text-xs sm:text-sm font-light text-center text-[rgba(255,255,255,0.8)]">
              Donation receipt will be sent via email within 3-5 business days
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default DonateSection;